import domain from './domain';

// Reset open task list data
export const resetClientOpenTaskListData = domain.createEvent('resetClientOpenTaskListData');
